module.exports = __webpack_public_path__ + "img/shelter.a1bd560e.svg";